import { Reducer } from "redux";

import { MarketsAction, MarketsActionTypes, MarketsState } from "./types";

const initialState: MarketsState = {
  markets: [],
  isLoading: false,
};

const reducer: Reducer<MarketsState, MarketsAction> = (state = initialState, action) => {
  switch (action.type) {
    case MarketsActionTypes.FETCH_REQUEST: {
      return { ...state, isLoading: true };
    }

    case MarketsActionTypes.FETCH_ERROR: {
      return { ...state, isLoading: false };
    }

    case MarketsActionTypes.FETCH_SUCCESS: {
      const { items } = action.payload;
      return { ...state, isLoading: false, markets: items };
    }

    default:
      return state;
  }
};

export default reducer;
